<template>
  <TzDialog
    ref="dialog"
    class="ic-dialog"
    :lock-scroll="lockScroll"
    :closed-by="closedBy"
    v-bind="$attrs"
    v-on="$listeners"
    @click.native="handleHashNavigation"
  >
    <slot />
  </TzDialog>
</template>

<script>
import TzDialog from '@trazi/tz-dialog/src/tz-dialog.vue';

export default {
  name: 'ic-dialog',
  components: { TzDialog },
  props: {
    /**
     * If 'any' the dialog will be closed by any click outside the dialog
     * If 'none' the dialog will not be closed by any click outside the dialog
     * If 'closerequest' the dialog can be dismissed with actions
     */
    closedBy: {
      type: String,
      default: 'any'
    },
    /**
     * If true, the scroll will be locked when the dialog is open
     */
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    /**
     * Keep hash links inside the dialog from scrolling the page
     *
     * @param {Event} event
     * @returns {void}
     */
    handleHashNavigation(event) {
      // Gets the link even if click was on element within link
      const link = event.target.closest('a[href^="#"]');
      // If no link was found, don't change any behavior
      if (!link) {
        return;
      }

      // Get the link href
      const href = link.getAttribute('href');
      // If href is empty or a # only, don't change any behavior
      if (!href || href.length < 2) {
        return;
      }

      // Otherwise prevent default behavior
      event.preventDefault();

      // Get the target id and remove #
      const targetId = decodeURIComponent(href.slice(1));
      // Get the dialog element
      const dialog = this.$el;
      // Search the modal for a matching id
      const target = dialog.querySelector(`[id="${targetId}"]`);
      // If no target was found, don't change any behavior
      if (!target) {
        return;
      }

      // If a valid target was found, scroll the dialog but not the page
      const dialogTop = dialog.getBoundingClientRect().top;
      const targetTop = target.getBoundingClientRect().top;
      dialog.scrollTop += targetTop - dialogTop;
    }
  }
};
</script>
<style lang="scss">
@import '~@/assets/scss/theme';
.ic-dialog {
  box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.3);
  .tz-dialog__inner {
    border-radius: 8px;
    height: auto; // prevent modal from collapsing on Safari due to percentages
  }
}
</style>
